import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import {UserAppletContainerModel} from "../../../../../../models/aggregates/applet-store/user-applet-container.model";


// https://api.akaun.cloud/core2/platform/dm/login-tenant-links/login-tenant-ep

@Injectable({
  providedIn: 'root'
})
export class TenantLoginLinksLoginTenantEpService extends BaseApiTemplateService<UserAppletContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'login-tenant-links/login-tenant-ep';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'login-tenant-links/login-tenant-ep';
    this.httpClient = http;
  }
}
